<input
  class="text-input"
  type="text"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [attr.aria-invalid]="error ? true : null"
  [maskito]="maskOptions"
  [value]="value"
  autocomplete="off"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)" />
